import api from '@/services/api'

/**
 * 保存蓝牙设备信息
 */
export function saveBluetoothDevice(deviceId, deviceName, userId) {
  return api.post('/bluetooth-printer/device', { deviceId, deviceName, userId })
}

/**
 * 获取用户的蓝牙设备列表
 */
export function getBluetoothDevices(userId) {
  return api.get('/bluetooth-printer/devices', { params: { userId } })
}

/**
 * 设置默认设备
 */
export function setDefaultBluetoothDevice(deviceId, userId) {
  return api.put(`/bluetooth-printer/device/${deviceId}/default`, null, { params: { userId } })
}

/**
 * 删除设备
 */
export function deleteBluetoothDevice(deviceId, userId) {
  return api.delete(`/bluetooth-printer/device/${deviceId}`, { params: { userId } })
}
